import * as types from '../constants/ActionTypes';
import config from '../../config/app.js';
import api from '../../config/api.js';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export function adminSearchUsers(s){
	return async (dispatch) => {
		// Check if we made a request
		if(source){
			// Cancel the previous request before making a new request
			source.cancel()
		}
		// Create a new CancelToken
		source = axios.CancelToken.source()
		try{
			const res = await api.get(`/users/search/${s}`, {cancelToken: source.token})
			const result = res.data
			return dispatch(adminSetUsers(result));
		} catch(error) {
			if(axios.isCancel(error)) {
				// Handle if request was cancelled
				console.log('Request canceled', error.message);
			} else {
				// Handle usual errors
				console.log('Something went wrong: ', error.message)
			}
		}
	}
}

export function adminSaveUser(user) {
	// eslint-disable-next-line
	return (dispatch) => {
		api.post('/admin/users/' + user.id, user)
			.then((d) => {
				dispatch(adminSetUser(d.data));
			});
	}
}

export function adminSetUser(user) {
	return {
		type: types.ADMIN_SET_USER,
		payload: user
	};
}

export function adminAddPatient(patient) {
	return (dispatch) => {
		api.put('/admin/patients', patient)
			.then(d => {
				dispatch({
					type: types.INSERT_PATIENT,
					payload: d.data
				})
			})
			.catch(e => {
				console.log('Error adding patient on the server', e)
			})
	}
}

export function adminUpdatePatient(patientId, patient) {
	return (dispatch) => {
		api.put(`/admin/patients/${patientId}`, patient)
			.then(d => {
				return dispatch({
					type: types.UPDATE_PATIENT,
					payload: d.data
				})
			})
			.catch(e => {
				console.log('Error adding patient on the server', e)
			})
	}
}

export function adminSetUserAdmin(userId) {
	return (dispatch, getState) => {
		let { users } = getState();
		let i = users.findIndex((u) => u.uid === userId);
		let user = users[i];
		user.admin = !user.admin;
		// set the users
		dispatch(adminSetUsers([
			...users.slice(0, i),
			user,
			...users.slice(i + 1)
		]));
		api.post('/admin/users', user)
			.then((d) => {
				//dispatch(adminSetUser(user));
			});
	}
}

export function adminSetUserConfirmed(userId) {
	return (dispatch, getState) => {
		let { users } = getState();
		let i = users.findIndex((u) => u.uid === userId);
		let user = users[i];
		user.confirmed = !user.confirmed;
		// set the users
		dispatch(adminSetUsers([
			...users.slice(0, i),
			user,
			...users.slice(i + 1)
		]));
		api.post('/admin/users', user)
			.then((d) => {
				//dispatch(adminSetUser(user));
			});
	}
}

export function adminFetchUsers() {
	if(config.setGuardians){
		// once off update patients database with guardians
		api.get('/admin/add_parent_to_guardians')
		.then(r=>{
			console.log(r);
		})
	}

	return (dispatch) => {
		if (api.defaults.headers.common['x-access-token']) {
			return api.get('/admin/users/')
				.then((d) => {
					dispatch(adminSetUsers(d.data));
					//dispatch(adminFetchUsersDone())
				});
		} else {
			dispatch(adminSetUsers([]))
		}
	}
}

export function adminSaveTherapyArea(area) {
	return (dispatch) => {
		api.post('/admin/therapy_areas/', area)
			.then((d) => {

				dispatch({
					type: types.UPDATE_THERAPY_AREA,
					payload: d.data
				});
			}).catch((e) => {
				console.log('Error saving therapy area at server', e);
			});
	}
}

export function adminSaveTherapyCategory(cat) {
	return (dispatch) => {
		api.post('/admin/therapy_categories/', cat)
			.then((d) => {

				dispatch({
					type: types.UPDATE_THERAPY_CATEGORY,
					payload: d.data
				});
			}).catch((e) => {
				console.log('Error saving therapy category at server', e);
			});
	}
}



export function adminSavePractice(practice) {
	return (dispatch) => {
		api.post(`/admin/practices/${practice._id}`, practice)
			.then((d) => {
				dispatch({
					type: types.UPDATE_PRACTICE,
					payload: d.data
				});
			}).catch((e) => {
				console.log('Error saving practice at server', e);
			});
	}
}

export function adminAssignPracticeOwner(practiceId, userId) {
	return (dispatch) => {
		api.post(`/admin/practice/set_owner/${practiceId}/${userId}`)
			.then((d) => {
				console.log(d)
				dispatch({
					type: types.UPDATE_PRACTICE,
					payload: d.data.practice
				});
				dispatch({
					type: types.ADMIN_SET_USER,
					payload: d.data.user
				});
			}).catch((e) => {
				console.log('Error saving practice at server', e);
			});
	}
}

export function adminRemovePracticeOwner(practiceId, userId) {
	return (dispatch) => {
		api.post(`/admin/practice/unset_owner/${practiceId}/${userId}`)
			.then((d) => {
				console.log(d)
				dispatch({
					type: types.UPDATE_PRACTICE,
					payload: d.data.practice
				});
				dispatch({
					type: types.ADMIN_SET_USER,
					payload: d.data.user
				});
			}).catch((e) => {
				console.log('Error un saving practice at server', e);
			});
	}
}

export function adminToggleVideoTherapyArea(area, videoId) {
	// is this video in the therapy area?
	if (area.videos.indexOf(videoId) === -1) {
		// no - add it
		area.videos.push(videoId);
	} else {
		area.videos = area.videos.filter(v => v !== videoId)
	}
	return {
		type: types.UPDATE_THERAPY_AREA,
		payload: area
	}
}

export function adminToggleCategoryTherapyArea(area, catId) {
	// is this video in the therapy area?
	if (area.categories.indexOf(catId) === -1) {
		// no - add it
		area.categories.push(catId);
	} else {
		area.categories = area.categories.filter(v => v !== catId)
	}
	return {
		type: types.UPDATE_THERAPY_AREA,
		payload: area
	}
}

export function adminCreatePracticeType(type) {
	return (dispatch) => {
		api.post('/admin/practice_type', type)
			.then((d) => {
				console.log('adminCreatePracticeType', d.data)
				dispatch({
					type: types.INSERT_PRACTICE_TYPE,
					payload: d.data
				});
			})
			.catch((e) => {
				console.log('Error inserting category type at server', e);
			});
	}
}

export function adminUpdatePracticeType(type) {
	return (dispatch) => {
		api.put('/admin/practice_type/' + type.id, type)
			.then((d) => {
				console.log('adminUpdatePracticeType', type)
				dispatch({
					type: types.UPDATE_PRACTICE_TYPE,
					payload: d.data
				});
			})
			.catch((e) => {
				console.log('Error updating category type at server', e);
			});
	}
}

export function adminDeletePracticeType(id) {
	return (dispatch) => {
		api.delete('/admin/practice_type/' + id)
			.then((d) => {
				console.log('adminDeletePracticeType', id)
				dispatch({
					type: types.DELETE_PRACTICE_TYPE,
					payload: d.data
				});
			})
			.catch((e) => {
				console.log('Error deleting category type at server', e);
			});
	}
}


export function adminCreateTherapyArea(area) {
	return (dispatch) => {
		api.put('/admin/therapy_areas/', area)
			.then((d) => {
				console.log('d', d.data)
				dispatch({
					type: types.INSERT_THERAPY_AREA,
					payload: d.data
				});
			}).catch((e) => {
				console.log('Error inserting therapy area at server', e);
			});
	}
}

export function adminCreateTherapyCategory(cat) {
	return (dispatch) => {
		api.put('/admin/therapy_categories/', cat)
			.then((d) => {
				console.log('d', d.data)
				dispatch({
					type: types.INSERT_THERAPY_CATEGORY,
					payload: d.data
				});
			}).catch((e) => {
				console.log('Error inserting therapy category at server', e);
			});
	}
}

export function adminDeletePractice(practiceId) {

	return dispatch => {
		return api.delete(`/practices/${practiceId}`)
			.then((d) => {
				return dispatch({
					type: types.DELETE_PRACTICE,
					payload: practiceId
				});
			}).catch((e) => {
				console.log('Error deleting practice at server', e);
				return e
			});
	}
}


export function adminDeleteTherapyArea(area) {

	return (dispatch) => {
		api.delete(`/admin/therapy_areas/${area}`)
			.then((d) => {

				dispatch({
					type: types.DELETE_THERAPY_AREA,
					payload: area
				});
			}).catch((e) => {
				console.log('Error deleting therapy area at server', e);
			});
	}
}

export function adminDeleteTherapyCategory(cat) {
	return (dispatch) => {
		api.delete(`/admin/therapy_categories/${cat}`)
			.then((d) => {
				dispatch({
					type: types.DELETE_THERAPY_CATEGORY,
					payload: cat
				});
			}).catch((e) => {
				console.log('Error deleting therapy category at server', e);
			});
	}
}

export function adminCreateVideo(video) {
	return (dispatch) => {
		api.put('/admin/videos/', video)
			.then((d) => {
				dispatch({
					type: types.INSERT_VIDEO,
					payload: d.data
				});
			}).catch((e) => {
				console.log('Error inserting video at server', e);
			});
	}
}

export function adminSaveVideo(video) {
	return (dispatch) => {
		//save video
		api.post('/admin/videos/', video)
			.then((d) => {
				dispatch({
					type: types.UPDATE_VIDEO,
					payload: d.data
				});
			}).catch((e) => {
				console.log('Error updating video at server', e);
			});
	}
}

export function adminDeleteVideo(video) {
	return (dispatch) => {
		api.delete(`/admin/videos/${video}`)
			.then((d) => {
				dispatch({
					type: types.DELETE_VIDEO,
					payload: video
				});
			}).catch((e) => {
				console.log('Error deleting video at server', e);
			});
	}
}



export function adminSetUsers(users) {
	return {
		type: types.ADMIN_SET_USERS,
		payload: users
	};
}



// WEBPACK FOOTER //
// ./src/actions/admin.js